module.exports = "<span class=\"payment-status-label\" ng-class=\"::$ctrl.statusClass\" ng-bind-html=\"::$ctrl.statusText\"></span>";